import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LocationService } from 'src/services/location.services';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { MessageService } from 'src/services/message.service';

@Component({
  selector: 'app-add-location',
  templateUrl: './add-location.component.html',
  styleUrls: ['./add-location.component.css']
})
export class AddLocationComponent implements OnInit {
  defaultTitle: string = "Confirm";
  isFormValid: boolean = true;
  mode: any;

  path: string = '../../assets/images/no-image.png';

  formGroup = new FormGroup({
    gln: new FormControl(),
    name: new FormControl(),
    address: new FormControl(),
    latitude: new FormControl(),
    longitude: new FormControl(),
    mobile: new FormControl('', Validators.maxLength(15)),
    userId: new FormControl(),
    email: new FormControl(),
    password: new FormControl('', [Validators.minLength(8), Validators.maxLength(64)]),
    confirmPassword: new FormControl('', [Validators.minLength(8), Validators.maxLength(64)])
  });

  constructor(
    private dialogRef: MatDialogRef<AddLocationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private locationService: LocationService,
    private globalCfgService: GlobalCfgService,
    private msgService: MessageService
  ) { }

  ngOnInit() {
    this.mode = this.data.mode;
  }

  cancel() {
    this.dialogRef.close();
  }

  onSubmit(rec) {
    rec.gcp = this.globalCfgService.getGcp();

    if (this.mode == 'edit') {
      rec.gln = this.data.rec.gln;
      this.locationService.update(rec).subscribe(
        ()=> {
          this.msgService.showSuccess(this.msgService.locationUpdate);
          this.dialogRef.close('yes');
        }
      );
    } else {
      this.locationService.add(rec).subscribe(
        (response)=> {
          this.msgService.showSuccess(this.msgService.locationCreate);
          this.dialogRef.close('yes');
        }
      );
    }
  }

}
